import {
	EmployeeStatusFilters,
	GoalStatusFilters,
	GoalTransparencyFilters,
	ReviewReportStatusFilters,
	ReviewStatusFilters,
	SurveyStatusFilters,
} from "../../../../schemas/report";

const Config = {
	// order matters here.
	defaultQuickFilters: {
		goalReport: [
			{
				id: "goalAssignee",
				label: "Assignee",
				type: "person",
			},
			{
				id: "department",
				label: "Group",
				type: "multiSelect",
			},
			{
				id: "goalCategories",
				label: "Category",
				type: "goalCategory",
			},
			{
				id: "goalCreatedBetweenDate",
				label: "Created Date Between",
				type: "dateRange",
			},
			{
				id: "goalStartBetweenDate",
				label: "Start Date Between",
				type: "dateRange",
			},
			{
				id: "goalDueBetweenDate",
				label: "Due Date Between",
				type: "dateRange",
			},
			{
				id: "goalStatus",
				label: "Status",
				type: "checkbox",
			},
			{
				id: "goalTransparency",
				label: "Transparency Level",
				type: "checkbox",
			},
			{
				id: "goalOutlook",
				label: "Outlook",
				type: "goalOutlook",
			},
		],
		employeeReport: [
			{
				id: "asOf",
				label: "Show Employee Data As Of",
				type: "date",
				info: "Set this date to narrow criteria to a specific moment in time",
			},
			{
				id: "employeeStatus",
				label: "Employee Status",
				type: "checkbox",
			},
			{
				id: "hiredBetween",
				label: "Employees Hired Between",
				type: "dateRange",
			},
			{
				id: "department",
				label: "Employee Group",
				type: "multiSelect",
			},
		],
		reviewReport: [
			{
				id: "reviewCycleNames",
				label: "Review Cycle",
				type: "multiSelect",
			},
			{
				id: "startedBetween",
				label: "Reviews Started Between",
				type: "dateRange",
			},
			{
				id: "completedBetween",
				label: "Reviews Completed Between",
				type: "dateRange",
			},
			{
				id: "reviewFormNames",
				label: "Review Form",
				type: "multiSelect",
			},
			{
				id: "department",
				label: "Employee Groups",
				type: "multiSelect",
			},
			{
				id: "reviewStatus",
				label: "Review Status",
				type: "checkbox",
			},
			{
				id: "reviewReportStatus",
				label: "Review Form Status",
				type: "checkbox",
			},
		],
		surveyReport: [
			{
				id: "surveyName",
				label: "Survey",
				type: "multiSelect",
			},
			{
				id: "surveyStartedBetween",
				label: "Survey Started Between",
				type: "dateRange",
			},
			{
				id: "surveyCompletedBetween",
				label: "Survey Ended Between",
				type: "dateRange",
			},
			{
				id: "surveyStatus",
				label: "Survey Status",
				type: "checkbox",
			},
		],
	},
	dateFields: [
		"startedBetween",
		"completedBetween",
		"hiredBetween",
		"goalCreatedBetweenDate",
		"goalStartBetweenDate",
		"goalDueBetweenDate",
		"surveyStartedBetween",
		"surveyCompletedBetween",
	],
	goalFieldsMap: {
		goalAssignee: "assignee",
		goalCategories: "categories",
		goalStatus: "status",
		goalTransparency: "transparency",
		goalOutlook: "outlook",
	},
	defaultFilterValues: {
		date: null,
		checkbox: [],
		dateRange: null,
		department: [],
		reviewCycleNames: [],
		reviewFormNames: [],
		goalCategory: [],
		goalOutlook: [],
		multiSelect: [],
	},
	checkBoxOptions: {
		employeeStatus: [
			{ value: EmployeeStatusFilters.Active, label: "Active" },
			{ value: EmployeeStatusFilters.Deactivated, label: "Deactivated" },
		],
		goalStatus: [
			{ value: GoalStatusFilters.Active, label: "Active" },
			{ value: GoalStatusFilters.Completed, label: "Completed" },
			{ value: GoalStatusFilters.Archived, label: "Archived" },
		],
		goalTransparency: [
			{ value: GoalTransparencyFilters.Private, label: "Private" },
			{ value: GoalTransparencyFilters.Public, label: "Public" },
		],
		reviewStatus: [
			{ value: ReviewStatusFilters.Completed, label: "Completed" },
			{ value: ReviewStatusFilters.Active, label: "Active" },
			{ value: ReviewStatusFilters.Scheduled, label: "Scheduled" },
		],
		reviewReportStatus: [
			{ value: ReviewReportStatusFilters.Completed, label: "Completed" },
			{ value: ReviewReportStatusFilters.InProgressAwaitingSubmission, label: "Awaiting Authors" },
			{ value: ReviewReportStatusFilters.InProgressAwaitingSignOff, label: "Awaiting Signers" },
		],
		surveyStatus: [
			{ value: SurveyStatusFilters.Open, label: "Open" },
			{ value: SurveyStatusFilters.Scheduled, label: "Scheduled" },
			{ value: SurveyStatusFilters.Closed, label: "Closed" },
		],
	},
};

export default Config;
